import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { LuFileCheck2 } from "react-icons/lu";

import { handleFetchResultsCount } from "../../api/results";

export default function ManageResults() {
  const { data: count } = useQuery({
    queryKey: ["resultCount"],
    queryFn: handleFetchResultsCount,
  });
  return (
    <Link
      to={`/admin/results`}
      className={`col-span-6 sm:col-span-4 lg:col-span-3 bg-white p-4 rounded-md mx-1 mt-1 sm:mx-1 sm:my-1`}
      style={{
        backgroundColor: "#FEC276",
        color: "#FFFFFF",
      }}
    >
      <div className="flex items-center justify-center">
      <div className="text-3xl sm:text-6xl border-r font-bold mx-2 sm:mx-4 px-2 sm:px-4">{count}</div>
        <div className="flex flex-col justify-center items-center">
          <div className="">
            <LuFileCheck2 color="#ffffff" size={40} />
          </div>
          <div className="">Results</div>
        </div>
      </div>
    </Link>
  );
}
